import React from 'react';
import PropTypes from 'prop-types';
import {Helmet} from 'react-helmet';
import ErrorBoundary from '@spothero/ui/error-boundary';
import SharedMeta from 'common/meta/SharedMeta';
import RouteProvider from './RouteProvider';

const RootDesktop = ({
    pageInitData
}) => {
    return (
        <ErrorBoundary>
            <SharedMeta />
            <Helmet>
                {/* eslint-disable react/jsx-max-props-per-line */}
                <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
                <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no" />
                {/* eslint-enable react/jsx-max-props-per-line */}
            </Helmet>
            <RouteProvider
                pageInitData={pageInitData}
                isMobile={false}
            />
        </ErrorBoundary>
    );
};

RootDesktop.propTypes = {
    pageInitData: PropTypes.shape({
        userData: PropTypes.object,
        cleanedParams: PropTypes.object,
        setupData: PropTypes.object
    }).isRequired
};

export default RootDesktop;
